var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibility24(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40499 13.2622C4.22306 13.0021 4.12549 12.6924 4.12549 12.375C4.12549 12.0576 4.22306 11.7479 4.40499 11.4878C5.58474 9.8175 8.48949 6.375 12.3752 6.375C16.261 6.375 19.1657 9.8175 20.3455 11.4878C20.5274 11.7479 20.625 12.0576 20.625 12.375C20.625 12.6924 20.5274 13.0021 20.3455 13.2622C19.1657 14.9325 16.261 18.375 12.3752 18.375C8.48949 18.375 5.58474 14.9325 4.40499 13.2622Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.375C14.0319 15.375 15.375 14.0319 15.375 12.375C15.375 10.7181 14.0319 9.375 12.375 9.375C10.7181 9.375 9.375 10.7181 9.375 12.375C9.375 14.0319 10.7181 15.375 12.375 15.375Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility24);
export default __webpack_public_path__ + "static/media/Visibility24.d27b0ec0.svg";
export { ForwardRef as ReactComponent };